import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Download } from 'lucide-react';
import type { RootState } from '~/redux/store';
import { UserRole } from '~/graphql/graphql';
import { Button } from '~/components/ui/buttons/Button';

type TenantAdminExportCsvButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

export function TenantAdminExportCsvButton({
  onClick,
  disabled = false,
}: Readonly<TenantAdminExportCsvButtonProps>) {
  const { t } = useTranslation('organizations');
  const isTenantAdmin = useSelector(
    (state: RootState) => state.auth.user?.role === UserRole.TenantAdmin
  );

  if (!isTenantAdmin) return null;

  return (
    <Button
      size="sm"
      width="auto"
      variant="secondary"
      disabled={disabled}
      onClick={onClick}
    >
      <Download size={16} className="mr-1" />
      {t('organizations.linked.exportCsv')}
    </Button>
  );
}
